import { http, HttpResponse } from 'msw';

import { Member } from 'modules/common/interfaces/member';

export const MOCK_MEMBER_UUID = 'mock-member-uuid-0001';

const mockMember: Partial<Member> = { id: 1, uuid: MOCK_MEMBER_UUID, status: 'active' };

const mockSearchMember = { id: 1, fullname: 'Jane Smith', email: 'jane@example.com', status: 'active' };

export default {
    member: http.get('*/members/', () => HttpResponse.json([mockMember])),
    membershipInfo: http.get('*/membershipinfo/', () => HttpResponse.json({ id: 1, status: 'active' })),
    membersSearch: http.post('*/hub/members/search/', () =>
        HttpResponse.json({ count: 1, next: null, previous: null, results: [mockSearchMember] })
    ),
    transactionStartDate: http.get('*/members/:id/transaction-start-date/', () =>
        HttpResponse.json({ transaction_start_date: '2025-01-01', formatted_date: 'Jan 1, 2025' })
    ),
};
